import { useCallback } from 'react';
import { useQueryClient } from 'react-query';

import { BookingRequest } from '../interfaces';
import { useBookingSummaryQueryKey } from './use-booking-summary.hook';

/**
 * Returns a function that will invalidate the given booking within the cache.
 * Use this when you want to trigger a reload of data.
 * @param request
 * @returns
 */
export const useInvalidateBookingSummary = (request: BookingRequest) => {
  const client = useQueryClient();
  const queryKey = useBookingSummaryQueryKey(request);

  return useCallback(() => client.refetchQueries(queryKey), [client, queryKey]);
};
